import * as React from "react";
import * as S from "@styled";
import { connect } from "react-redux";

import { DiffEdit, observableDiff } from "deep-diff";

import { PageLoadSpinner } from "../../shared/components/PageLoadSpinner";

import { Link } from "react-router-dom";
import { BpmnDiffer, DiffSide } from "../../processDiff/BpmnDiffer";
import { DiffVersionHeader } from "../../processDiff/DiffVersionHeader";
import { ProcessVersionDetails } from "../../processList/model/ProcessVersion";
import { HashMap } from "../../shared/model/HashMap";
import { Utilities } from "../../shared/utilities";
import { IElementDictionary, IProcessData } from "../model/IProcessData";
import { State } from "../model/State";

class DiffWorkingProcess extends React.Component<DiffWorkingProcessProps, DiffWorkingProcessState> {
    constructor(props: DiffWorkingProcessProps) {
        super(props);
        this.state = {
            processToCompare: null,
            elementParametersToCompare: null,
            isLoading: true,
            elementParameterDiff: null,
            processVersions: []
        };
    }

    public async componentDidMount() {
        const diffState = await this.getDiffData();
        const versionsForProcess = await Utilities.postJsonAndParseResponse<HashMap<ProcessVersionDetails[]>>(`api/processList/processVersions`, [this.props.workingProcess.uniqueIdentifier]);
        this.setState(
            Object.assign({}, this.state, diffState, { processVersions: versionsForProcess[this.props.workingProcess.uniqueIdentifier as string], isLoading: false })
        );

    }

    public render() {
        if (this.state.isLoading) {
            return <PageLoadSpinner />;
        }

        return <>
            <S.DiffHeader className={"left"}>
                <S.DiffProcessName>
                    {this.props.workingProcess.name}
                </S.DiffProcessName>
            </S.DiffHeader>

            <DiffVersionHeader
                side={DiffSide.Right}
                baseUri={`${this.props.workingProcess.isSubprocess ? "Subprocess" : "Process"}/Diff/${this.props.workingProcess.uniqueIdentifier}?leftVersion=${this.props.workingProcess.version}&rightVersion=`}
                process={this.state.processToCompare}
                processVersionsToShow={this.state.processVersions}
                onVersionChanged={this.handleLeftVersionChanged}
                pullRight={true}
            />

            <BpmnDiffer
                key={this.state.processToCompare?.version} // Re create the component if the right side process changes
                processLeft={this.state.processToCompare}
                processRight={this.props.workingProcess}
                elementParametersLeft={this.state.elementParametersToCompare}
                elementParametersRight={this.props.workingProcessParameters}
                parameterDiff={this.state.elementParameterDiff}
            />

            <S.BottomBar isShown={true} >
                <S.Button as={Link} to={{ pathname: this.props.path }}>
                    {FRENDS.Localizations.Close}
                </S.Button>
            </S.BottomBar>
        </>;
    }

    private async getDiffData(compareToVersion?: number): Promise<Partial<DiffWorkingProcessState>> {
        const processDataToCompare = await Utilities.getFetch<IProcessData>(`api/process`, {
            Guid: this.props.workingProcess.uniqueIdentifier as string,
            Version: (compareToVersion && compareToVersion.toString()) as string
        });

        const comparedElementParameters = Utilities.arrayToObject(processDataToCompare.elementParameters, "id");
        const diffs: { [key: string]: any } = {};
        observableDiff(comparedElementParameters, this.props.workingProcessParameters, (d) => {
            if (d.kind === "E" && d.path !== undefined) {
                if (diffs[d.path[0]]) {
                    diffs[d.path[0]].push(d);
                } else {
                    diffs[d.path[0]] = [d];
                }
            }
        });

        return {
            processToCompare: processDataToCompare,
            elementParametersToCompare: comparedElementParameters,
            elementParameterDiff: diffs
        };
    }

    private handleLeftVersionChanged = async (version: number) => {
        const diffState = await this.getDiffData(version);
        this.setState(
            Object.assign({}, this.state, diffState)
        );
    }
}

interface DiffWorkingProcessStateProps {
    workingProcess: IProcessData;
    workingProcessParameters: IElementDictionary;
    path: string;
}

interface DiffWorkingProcessOwnProps {
}

interface DiffWorkingProcessState {
    processToCompare: IProcessData | null;
    elementParametersToCompare: IElementDictionary | null;
    isLoading: boolean;
    elementParameterDiff: { [key: string]: Array<DiffEdit<{}, {}>> } | null;
    processVersions: ProcessVersionDetails[];

}

export type DiffWorkingProcessProps = DiffWorkingProcessOwnProps & DiffWorkingProcessStateProps;

function mapStateToProps(state: State, ownProps: DiffWorkingProcessOwnProps): DiffWorkingProcessStateProps {
    const workingProcess = state.process as unknown as IProcessData; // hacky :(
    workingProcess.version = (workingProcess.version as number)++;
    return {
        workingProcess: workingProcess,
        workingProcessParameters: state.elements,
        path: state.router.location.pathname

    };
}

export default connect(mapStateToProps)(DiffWorkingProcess);
